import { Circle, Star, Whatshot } from '@mui/icons-material';
import { TrendingListItemType } from '@on3/api';

import styles from './Tag.module.scss';

type TagType = TrendingListItemType | string;

export const Tag = ({ type }: { type: TagType }) => {
  switch (type) {
    case TrendingListItemType.Trending:
    case 'trending':
      return (
        <span className={styles.tag} data-type="trending">
          Trending
        </span>
      );
    case TrendingListItemType.New:
    case 'new':
      return (
        <span className={styles.tag} data-type="new">
          New
        </span>
      );
    case TrendingListItemType.Hot:
    case 'hot':
      return (
        <span className={styles.tag} data-type="hot">
          <Whatshot />
          Hot
        </span>
      );
    case TrendingListItemType.Live:
    case 'live':
      return (
        <span className={styles.tag} data-type="live">
          <Circle />
          Live
        </span>
      );
    case TrendingListItemType.Breaking:
    case 'breaking':
      return (
        <span className={styles.tag} data-type="breaking">
          Breaking
        </span>
      );
    case TrendingListItemType.BetMGM:
    case 'betmgm':
      return (
        <span className={styles.tag} data-type="betmgm">
          <img
            alt="BetMGM Logo"
            src="https://on3static.com/static/on3/mgm-branding.svg"
          />
        </span>
      );
    case 'featured':
      return (
        <span className={styles.tag} data-type="featured">
          <Star />
          Featured
        </span>
      );
    case 'funny':
      return (
        <span className={styles.tag} data-type="funny">
          Funny!
        </span>
      );
    default:
      return (
        <span className={styles.tag} data-type="general">
          {type}
        </span>
      );
  }
};
